import { ActionTypes } from "redux/actions/actionType";

// types
import { ContainersTableType, ContainerType, WarehouseStatsType, ContainerReservationsType } from 'types/types';


export const setContainers = ( containers: ContainersTableType, totalCount: number ) => {
    return {
        type: ActionTypes.SET_CONTAINERS,
        payload: {containers, totalCount}
    }
};

export const setContainer = ( container: ContainerType ) => {
    return {
        type: ActionTypes.SET_CONTAINER,
        payload: container,
    }
};

export const setWarehouses = ( warehouses: WarehouseStatsType []) => {
    return {
        type: ActionTypes.SET_WAREHOUSES,
        payload: warehouses,
    }
};

export const setContainerReservations = ( containerReservations: ContainerReservationsType, totalCount: number ) => {
    return {
        type: ActionTypes.SET_CONTAINER_RESERVATIONS,
        payload: {containerReservations, totalCount}
    }
};
